import { createDataNode, createDataRef } from '../nodeFactory/dataNodeUtils'
import { Style } from '@wix/thunderbolt-becky-types'

export const background = createDataNode({
	getDependencies: (data: Style & { svg: string }) => {
		const svg = data?.svg
		return svg ? createDataRef('data', 'theme_data', svg) : undefined
	},
	toViewItem: (data, schemaDependencies, svg) => {
		if (svg) {
			return { ...data, svg }
		}
		return data
	},
})
